<template>
  <left-stripe-layout
    class="d-flex flex-column justify-start"
    :color="announcement.color"
  >
    <Header
      class="header"
      :large="false"
      :two-line="false"
      :color="announcement.color"
      :icon="announcement.iconName"
      :text="displayShort && announcement.shortTitle ? announcement.shortTitle : announcement.title"
    ></Header>
    <div class="main flex-grow-1">
      <div v-if="dataToTable.length !== 0 || isPreview" class="table-wrapper">
        <v-data-table
          dark
          :headers="headers"
          :items="isPreview ? previewData : sortedTableData"
          hide-default-header
          hide-default-footer
          class="elevation-1 table"
        >
          <template v-slot:item="props">
            <tr v-bind:class="{activev: props.item.active}">
              <td class="border pl-3" style="width: 10%"><img class="image" :src="props.item.icon"></td>
              <td :class="`item-text${isParallel ? '-parallel' : ''} border`" style="width: 15%">{{props.item.ticketNumber}}</td>
              <!-- <td class="" style="width: 5%"> [ {{props.item.direction}} ]</td> -->
              <td :class="`item-text${isParallel ? '-parallel' : ''} border`" style="width: 20%; white-space: nowrap">{{props.item.doors}}</td>
              <td :class="`item-text${isParallel ? '-parallel' : ''} border pr-1`" style="width: 55%">{{ props.item.active ? localization[currentLanguage]['messages']['please_enter'] : localization[currentLanguage]['messages']['doing']}}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="div_nothing" v-else>
        <span class="item-text">{{ this.localization[this.currentLanguage]['messages']['req_in_que']}}</span>
      </div>
    </div>
    <div class="footer" v-if="pauses.length > 0 || isPreview">
      <Marquee :items="isPreview ? previewPauses : pauses" class="pauses" />
    </div>
  </left-stripe-layout>
</template>

<script>
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import Header from "../../../components/Header";
import Marquee from "../../../components/Marquee";
import {config} from "../../../config";
import {mapGetters, mapActions} from 'vuex';
import Cz from "@/localization/i18n/cz.js"
import En from "@/localization/i18n/en.js"
import LeftStripeLayout from './Layouts/LeftStripeLayout.vue';

export default {
  name: "StudyDepartmentCallIn",

  props: {
    announcement: Object,
    isLandscape: Boolean,
    isParallel: Boolean,
    isPreview: Boolean
  },

  components: {
    Marquee,
    Header,
    LeftStripeLayout,
  },

  data() {
    return {
      windowHeight: window.innerHeight,

      connected: false,

      URL: config.serverUrl,

      headers: [
        {text: 'Icon', align: 'start', value: 'icon'},
        {text: 'Ticket Number', value: 'ticketNumber'},
        {text: 'Direction', value: 'direction'},
        {text: 'Doors', value: 'doors'},
        {text: 'Time', value: 'time'},
      ],

      dataToTable: [],

      pauses: [],

      startToMarquee: false,
      localization: {
        [config.cz]: Cz,
        [config.en]: En
      },
      currentLanguage: config.cz,
      cz: config.cz,
      en: config.en,

      previewData: [
        { icon: '/crocodile.png', ticketNumber: '001', doors: 'Q1.83', active: false },
        { icon: '/koala.png', ticketNumber: '002', doors: 'Q1.85', active: true }
      ],

      previewImage: null
    }
  },

  created() {
    this.isPreview || this.connect();
    this.image = this.isPreview ? this.getImage : null;
    this.fetchAssistants();
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight;
    });
    this.currentLanguage = this.announcement.language;
  },

  destroyed() {
    this.isPreview || this.disconnect();
  },

  computed: {
    ...mapGetters('Assistant', ['getAssistant']),
    ...mapGetters('StudyDepartmentCallIn', ['getImage']),

    previewPauses() {
      return [
        `Mgr. Jana Poláková ~15 m ${this.currentLanguage === this.cz ? 'přestávka - schůze' : 'pause - meeting'}`,
        `Jaromír Vaněk ~15 m ${this.currentLanguage === this.cz ? 'přestávka - schůze' : 'pause - meeting'}`,
        `Ing. Karel Brázda ~30 m ${this.currentLanguage === this.cz ? 'přestávka - oběd' : 'pause - lunch'}`,
        `Andrea Novotná ~30 m ${this.currentLanguage === this.cz ? 'přestávka - oběd' : 'pause - lunch'}`
      ]
    },

    sortedTableData() {
      // sort to have active at the top, others sorted by the time when they became active (called in)
      return this.dataToTable
        .slice()
        .sort((a, b) => b.active - a.active || b.timeOfCallIn - a.timeOfCallIn);
    },

    displayShort() {
      return this.isParallel && this.isLandscape;
    },
    announcementLanguage() {
      return this.announcement.language;
    },
  },

  methods: {
    ...mapActions('Assistant', ['fetchAssistants']),

    playDing() {
      //let audio = new Audio(require('../../../assets/classic_hurt.mp3'));
      let audio = new Audio(require('../../../assets/airport.mp3'));
      audio.play();
    },

    connect() {
      this.socket = new SockJS(this.URL + "socket");
      this.stompClient = Stomp.over(this.socket);
      if (config.env === "production") {
        this.stompClient.debug = () => {};
      }
      this.stompClient.connect({},
        () => {
          this.connected = true;

          this.stompClient.subscribe(`/study-department/tv`, message => {
            this.setItemsToTable(JSON.parse(message.body));
          });

          this.stompClient.subscribe(`/study-department/tv-pauses`, message => {
            if (JSON.parse(message.body).length === 0) {
                this.pauses = [];
            } else {
                this.setPausesItems(JSON.parse(message.body));
            }
          });

          this.stompClient.send("/app/study-department/request-tv", null, {});
        },
        error => {
          console.error('Socket connection error:', error);
          console.info('Reconnecting websocket in 10 seconds.');

          this.connected = false;

          setTimeout(() => this.connect(), 10000);
        },
      );
    },

    setPausesItems(items) {
      this.pauses = [];

      for (let item of items) {
        if (item.status === 'active') {
          const assistantName = this.getAssistant(item.assistantId).name;

          let txt = assistantName.trim() + "\xa0~" + item.duration + "m přestávka/break" // not changing dynamically because that resets marquee

          if (item.note !== "") {
            txt += "\xa0-\xa0" + item.note.trim()
          }

          this.pauses.push(txt);
        }
      }
    },

    setItemsToTable(messageBody) {
      // find if the ticket already exists in the table
      let index = this.dataToTable.findIndex(i => i.queueItemStatusId === messageBody.queueItemStatusId);

      // remove old tickets
      if (!['active', 'doing'].includes(messageBody.active)) {
        if (index !== -1) { // remove only if exists
          this.$delete(this.dataToTable, index);
        }
        return; // stop further processing, we do not want closed tickets on TV
      }

      // process the incoming ticket and add it to the data table
      const item = {
        icon: `${config.serverUrl}study_department/images/${messageBody.animalImagesId}`,
        ticketNumber: messageBody.ticketNumber,
        direction: messageBody.direction,
        doors: messageBody.doors,
        time: messageBody.active === 'active' ? this.$t('messages.please_enter') : this.$t('messages.doing'),
        active: messageBody.active === 'active',
        queueItemStatusId: messageBody.queueItemStatusId,
        timeOfCallIn: (new Date()).getTime(), // ms unix epoch
      };

      if (index !== -1) {
        this.$set(this.dataToTable, index, item);
      } else {
        this.dataToTable.push(item);
      }

      // play a sound for ticket being called in
      if (messageBody.active === 'active') {
        this.playDing();
      }
    },

    disconnect() {
      if (this.stompClient) {
          this.stompClient.disconnect();
      }
      this.connected = false;
    },
  },

  watch: {
    announcementLanguage(val) {
      this.currentLanguage = val;
    }
  }
}
</script>

<style scoped>

.main {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  margin-right: -5px;
}

.single .header {
  margin-top: 3%;
  margin-bottom: 2%;
}

.table-wrapper {
  width: 100%;
}

.table {
  background-color: black !important;
}

.item-text {
  font-size: 2.5vw !important;
  font-weight: bold;
  color: white;
}

.item-text-parallel {
  font-size: 1.7vw;
  font-weight: bold;
  color: white;
  padding: 0 10px !important;
}

.activev {
  background-color: var(--base-color);
  animation: blinkingBackground 1s infinite !important;
  border-width: 0 !important;
}

@keyframes blinkingBackground {
  50% {
    background-color: var(--base-color);
  }
  100% {
    background-color: black;
  }
}

tr:not(:first-child) td.border {
  border-top: 0.3vh solid #505050 !important;
}

td.border {
  border-width: 0;
}

.border {
  border-spacing: 0 !important;
}

.theme--dark.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background-color: black !important;
}

.div_nothing {
  height: inherit !important;
  width: inherit !important;
}

.image {
  max-height: 5vw;
  max-width: 5vw;
  margin-left: 0;
  margin-top: 0.5rem;
}

.announcement {
  background: black;
  color: white;
  overflow: hidden;
  font-family: 'Roadgeek';
}

.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 7vh;
  width: 100%;
  background-color: dimgrey;
  font-weight: bold;
  color: white;
  font-size: 3.4vh;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  font-family: 'Roadgeek';
}

.pauses {
  font-weight: bold;
  font-size: 3.4vh;
}
</style>
